import { createFileRoute, redirect } from '@tanstack/react-router'
import SummaryDashboard from '@dashboard/SummaryDashboard'
import { SummaryDashboardErrorComponent } from '@dashboard/SummaryDashboard/SummaryDashboardError'
import { DashboardQueries } from '@dashboard/data'
import { StagesBar } from '@navigator/EntityPage/screens/DetailPage/components'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/summary')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements, scope } }) => {
    if (!scopedEnablements.for(scope).hasStandardEnablement('SummaryDashboard', 'READ')) {
      throw redirect({
        from: Route.fullPath,
        to: '..',
        replace: true,
      })
    }
  },
  loader: async ({ context: { queryClient }, params: { entityId } }) => {
    return queryClient.ensureQueryData(DashboardQueries.summaryDashboards(entityId))
  },
  errorComponent: SummaryDashboardErrorComponent,
})

function RouteComponent() {
  const { entityId } = Route.useParams()
  const { entityType } = Route.useRouteContext()
  const dashboard = Route.useLoaderData()

  return (
    <>
      {entityType?.features.includes('STAGES') && <StagesBar addTopSpacingWhenVoteBannerHidden />}
      {dashboard ? (
        <SummaryDashboard entityId={entityId} />
      ) : (
        <SummaryDashboardErrorComponent message="noneConfig" />
      )}
    </>
  )
}
